/*******************************************************************************
 *
 * This file is part of the LGS1920/studio project.
 *  
 * File: style.css
 *
 * Author : LGS1920 Team
 * email: studio@lgs1920.fr
 *
 * Created on: 2026-06-19
 * Last modified: 2026-06-19
 *
 *
 * Copyright © 2026 LGS1920
 ******************************************************************************/

:root {
    --lgs-profile-pane-height: 280px;
    --lgs-profile-chart-height: 200px;
    --lgs-vertical-panel-open-offset: 0;
}

#profile-pane {
    --header-spacing: 0;
    --footer-spacing: 0;
    --body-spacing: 0;
    --body-spacing: var(--lgs-gutter-s);
    --size: var(--lgs-profile-pane-height);
    width: var(--lgs-horizontal-panel-width);
}

#profile-pane::part(base) {
    margin-left: var(--lgs-horizontal-panel-left);

}

#profile-pane::part(panel) {
    border-radius: var(--sl-border-radius-medium);
    padding: var(--body-spacing);
}

#profile-pane::part(title) {
    display: none;
}

.profile-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-content: center;
}

#profile-pane::part(header-actions) {
    z-index: 1;
}

#profile-pane::part(header-actions) {
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    gap: var(--sl-spacing-2x-small);
    margin: var(--header-spacing);
    width: 100%;
    flex: 1 1;
}

#profile-pane header::part(title) {
    display: none;
}

.widget-background-section {
    display: flex;
    flex-direction: column;
    gap: var(--lgs-gutter-xs);
}

.profile-widget-editor {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    gap: var(--lgs-gutter);
}

.profile-widget-preview-surface {
    display: flex;
    overflow: hidden;
    align-items: center;
    width: 100%;
    flex: 1 1 auto;
    justify-content: center;
    min-height: 250px;
    height: 100%;
    padding: var(--lgs-gutter-s);

    border-radius: var(--sl-border-radius-medium);
    background-color: var(--sl-panel-background-color);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.profile-widget-preview-chart {
    display: block;
    max-width: 100%;
    max-height: 100%;
}

.profile-widget-ratio-section {
    display: flex;
    flex-direction: column;
    gap: var(--lgs-gutter-xs);
}

.profile-widget-ratio-custom-fields {
    display: flex;
    flex-direction: column;
    gap: var(--lgs-gutter-xs);
}

.profile-widget-ratio-row {
    width: 100%;
}

.profile-widget-ratio-row wa-number-input,
.profile-widget-ratio-row sl-input {
    width: 100%;
}

.profile-widget-preview-surface .profile-chart-container {
    box-sizing: border-box;
}

.profile-chart-container {
    position: relative;
}

.profile-widget-editor-scroll {
    flex: 1 1 auto;
    min-height: 0;
}

sl-input.widget-border-field-width::part(input) {
    width: 2.5rem;
    padding-right: 0;
    padding-left: 5px
}

.lgs-ui-toolbar.lgs-ui-dropdown-toolbar {
    display: none
}

.lgs-ui-toolbar wa-divider + wa-divider {
    display: none
}

.profile-chart-metric-badge {
    font-family: var(--lgs-font-family);
    font-size: clamp(10px, 1.15vh, var(--lgs-font-size));
    font-weight: 700;
    line-height: 1;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    max-width: calc(100% - 12px);
    padding: 3px 6px;
    pointer-events: none;
    color: var(--wa-color-brand-on-normal, var(--wa-color-brand));
    border: 1px solid var(--wa-color-brand-border-normal, var(--wa-color-surface-border));
    border-radius: 6px;
    background: color-mix(in oklab, var(--wa-color-surface-raised) 90%, transparent);
    box-shadow: 0 2px 8px rgb(0 0 0 / 22%);
    gap: 4px;
}

.profile-chart-metric-badge--hidden {
    display: none;
}

.profile-chart-metric-badge__value,
.profile-chart-metric-badge__altitude {
    min-width: 0;
    white-space: nowrap;
}

.profile-chart-metric-badge__value {
    overflow: hidden;
    text-overflow: ellipsis;
}

.profile-chart-metric-badge__altitude {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    color: inherit;
    gap: 0;
}

.profile-chart-metric-badge__chevron {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    color: inherit;
}

.profile-chart-metric-badge__chevron wa-icon,
.profile-chart-metric-badge__altitude wa-icon {
    display: block;
    width: 0.8em;
    height: 0.8em;
    color: currentColor;
}

.profile-chart-metric-badge__chevron wa-icon::part(svg),
.profile-chart-metric-badge__altitude wa-icon::part(svg) {
    color: currentColor;
    fill: currentColor;
}

.profile-chart-metric-badge__separator {
    display: block;
    align-self: center;
    flex: 0 0 1px;
    width: 1px;
    height: 1em;
    min-height: 1em;
    background: var(--lgs-card-on-map-border-color, var(--wa-color-surface-border));
}

#elevation-distance-tooltip {
    font-size: var(--lgs-font-size-s);
    font-family: var(--lgs-font-family);
    line-height: 1;
    display: flex;
    flex-direction: column;
    margin: var(--lgs-gutter-xs);
    gap: var(--lgs-gutter-xs);
}

#elevation-distance-tooltip .tooltip-icon {
    display: flex;
    align-items: center;
}

#elevation-distance-tooltip .tooltip-data {
    display: flex;
    align-items: center;
    background: white;
    padding: var(--lgs-gutter-xs);
    z-index: 1;
}

#elevation-distance-tooltip .tooltip-data.altitude {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}

#elevation-distance-tooltip .point-distance {
    display: flex;
    justify-content: space-between;
    padding: 0;
    align-items: center;
    align-content: center;
    gap: var(--lgs-gutter-s);
    position: relative;
    --line-color: black
}

#elevation-distance-tooltip .point-distance.line span:first-child .tooltip-icon {
    text-align: left
}

#elevation-distance-tooltip .point-distance.line span:last-child .tooltip-icon {
    text-align: right
}

#elevation-distance-tooltip .point-distance .tooltip-icon sl-icon:host {
    width: 20p;
}

.profile-toolbar {
    display: flex;
    gap: var(--lgs-gutter-s);
    justify-content: space-between;
    flex: 1;

    container-type: size;
    container-name: profile-toolbar;
    align-items: center;

}

.profile-toolbar .journey-selector {
    flex-basis: 50%;
}

.profile-toolbar .journey-selector::part(combobox) {
    max-width: 30rem;
}

.profile-toolbar .profile-tools-part {
    flex-basis: 40%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: var(--lgs-gutter-s);
    margin-left: auto
}

.profile-toolbar .lgs-ui-toolbar {
    justify-self: flex-end;
}

.profile-toolbar .replay-menu {
    display: flex;
    gap: var(--lgs-gutter-xs);
}

.profile-additional {
    display: flex;
    padding: 0 var(--sl-spacing-2x-small);
}

.lgs-ui-dropdown-toolbar .profile-additional {
    flex-direction: column;
}

@container profile-toolbar ( width <= 800px) {
    .profile-toolbar .journey-selector {
        flex-grow: 1;
        flex-basis: 50%;
    }

    .lgs-ui-toolbar.lgs-ui-dropdown-toolbar {
        display: flex
    }

    .lgs-ui-toolbar:not(.lgs-ui-dropdown-toolbar) {
        display: none
    }
}

.profiler-time-axis {
    position: absolute;
    left: 73px;
    width: 1027px;
    background: antiquewhite;
}

.profile-chart-container {
    padding: var(--lgs-gutter-s);
    border: 1px solid #ffffffaa;
    border-radius: var(--lgs-border-radius-s);
    background: #ffffff66;
    backdrop-filter: blur(var(--lgs-blur-s));
}

.reset-profile-widget-color {
    font-size: var(--lgs-font-size);
}

.profile-chart-switches {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 2rem
}

.profile-widget-replay-track-style-switch::part(base) {
    width: 100%;
}
